import { useMixpanelTableAction } from '@/utilities/mixpanel';
import { computed, reactive, ref } from 'vue';
const DEFAULT_FIELDS = {
    name: '',
    email: '',
    profile: '',
};
export function useUsersFilters(onReset) {
    const searchTerm = ref('');
    const searchFields = reactive({ ...DEFAULT_FIELDS });
    const statusFilter = ref('active');
    const formatFilterValues = computed(() => {
        return Object.entries(searchFields).flatMap(([column, value]) => {
            if (!value || value.trim() === '')
                return [];
            return [{ column, value }];
        });
    });
    const getEnabledValue = computed(() => {
        return (status) => {
            if (Array.isArray(status) && status.length > 1)
                return '';
            const statusValue = Array.isArray(status) ? status[0] : status;
            return statusValue === 'active' ? '1' : '0';
        };
    });
    const filteredStatusValues = computed(() => {
        const statusValue = statusFilter.value;
        if (Array.isArray(statusValue)) {
            return statusValue;
        }
        if (statusValue && statusValue !== 'active') {
            return [statusValue];
        }
        return ['active'];
    });
    function ensureReset() {
        if (onReset)
            onReset();
    }
    function updateField(property, value) {
        if (!property)
            return;
        ensureReset();
        searchFields[property] = value;
    }
    function handleSearchTerm(nameSearch, column) {
        useMixpanelTableAction('settings-users_clicked_filter', column.property, { searchValue: nameSearch });
        updateField(column.property, nameSearch);
    }
    function clearSearchTerm(column) {
        useMixpanelTableAction('settings-users_clicked_clear-filter', column.property);
        updateField(column.property, '');
    }
    function setStatusFilter(status) {
        ensureReset();
        statusFilter.value = status;
    }
    return {
        searchTerm,
        searchFields,
        statusFilter,
        filteredStatusValues,
        formatFilterValues,
        getEnabledValue,
        handleSearchTerm,
        clearSearchTerm,
        setStatusFilter,
    };
}
